import '.a{display:grid;}.ssr-plugin'
import '.ig{grid-template-columns:repeat(2, minmax(250px, 1fr));}.ssr-plugin'
import '.jc{column-gap:1.5rem;}.ssr-plugin'
import '.jd{row-gap:1rem;}.ssr-plugin'
import Column from '@app/components/layout/Column'
import useMediaQuery from '@app/util/useMediaQuery'
import { SectionHeader } from '@app/components/blocks/sectionHeader/SectionHeader'
import { useLanguage } from '@i18n/useLanguage'
import { i18n } from '@i18n/index'
import { InitiativeCard } from '@app/components/blocks/card/InitiativeCard'
import { styled } from 'inlines'
import { enrich } from '@i18n/localizeHelper'
import { RegionalListPlotModel } from 'functions/app/plot/list-regional'
import { useQuery } from '@based/sdk'
import defaultProjectPicture from '@app/assets/defaultProjectPicture.png'
import { pages } from '@app/util/links'
import { GeoViewModel } from './models'
import { labelAddressBuilder } from '@app/util/helpers'
import { Empty } from '@app/components/blocks/empty/Empty'
import FindLocationImage from '@app/assets/images/find-location.png'

export const Locations = ({ entity }: { entity: GeoViewModel }) => {
  const isRegion = 'municipalities' in entity
  const locationListingContext = 'regionalLocation'
  const isMobile = useMediaQuery()
  const largerGap = isMobile ? '2rem' : '1.5rem'
  const [language, _] = useLanguage()
  const translations = i18n.languages[language].app

  const listPayload = isRegion
    ? { regionId: entity.id }
    : { municipalityId: entity.id }
  const plotQuery = useQuery('list-regional-plot', listPayload)
  const plots: RegionalListPlotModel[] = plotQuery.data ?? []

  const title = enrich(
    translations.regionPage.locationsIn ??
      `${translations.regionPage.locations} in {0} ({1})`,
    entity.name,
    plots.length,
  )
  return (
    <Column gap={largerGap} alignItems="stretch">
      <SectionHeader title={title} />

      {plots.length === 0 ? (
        <Empty
          title={translations.regionPage.noLocationsTitle}
          imageSrc={FindLocationImage}
        >
          {translations.regionPage.noLocationsDescription}
        </Empty>
      ) : (
        <styled.div className="a ig jc jd"
          style={{
            '@media (max-width: 1200px)': {
              gridTemplateColumns: 'repeat(1, minmax(250px, 1fr))',
            },}}
        >
          {plots.map((plot) => {
            return (
              <InitiativeCard
                key={plot.slug}
                image={plot.media?.[0] ?? defaultProjectPicture}
                title={plot.name}
                description={plot.description}
                location={labelAddressBuilder(
                  plot.location?.address,
                  translations.common.notSpecified,
                  locationListingContext,
                )}
                tagText={
                  translations.common.plotApplicationStatus?.[
                    plot.applicationStatus
                  ] ?? plot.applicationStatus
                }
                tagVariant={
                  plot.applicationStatus === 'applicationOpen'
                    ? 'success'
                    : 'neutral'
                }
                to={pages.plot(plot.slug)}
              />
            )
          })}
        </styled.div>
      )}
    </Column>
  )
}
